const tapAction = window.ontouchstart === null ? 'touchstart' : 'click';

export const doNavigation = (cal, vp) => {

    let calendar_months = cal.querySelectorAll('.calendar__month');
    let viewDesktop = 2; // Amount of cal per view on desktop
    let viewMobile = 1; // Amount of cal per view on mobile
    let currentView = viewMobile;

    // Add Class for 1 month view
    cal.classList.add('calendar--1m');
    if(vp && window.innerWidth > vp) {
        currentView = viewDesktop;
        cal.classList.remove('calendar--1m');
    }
    
    if(calendar_months && calendar_months.length > currentView) {
        for (let index = 0; index < calendar_months.length; index++) {
            const calendar_month = calendar_months[index];
            const prev_month = index - 1;
            const next_month = index + 1;
            
            let isFirst = prev_month <= -1;
            let isLast = next_month === calendar_months.length ;

            let prevButton = calendar_month.querySelector('.calendar__nav--prev');
            let nextButton = calendar_month.querySelector('.calendar__nav--next');

            prevButton.disabled = false;
            nextButton.disabled = false;

            isFirst ? prevButton.disabled = true : null;
            isLast ? nextButton.disabled = true : null;

            prevButton.addEventListener( tapAction, () => {
                // Resets and remove all active classes
                calendar_months.forEach((cm) => {
                    cm.classList.remove('calendar__month--active');
                });

                // Adds active classes
                calendar_months[prev_month].classList.add('calendar__month--active');

                if(currentView > 1) {
                    calendar_months[prev_month + 1].classList.add('calendar__month--active');
                }
				cleanup_first_second()
            });
            
            nextButton.addEventListener( tapAction, () => {
                // Resets and remove all active classes
                calendar_months.forEach((cm) => {
                    cm.classList.remove('calendar__month--active');
                });

                if(calendar_months[next_month]) {
                    calendar_months[next_month].classList.add('calendar__month--active');
                }

                if(currentView > 1) {
                    calendar_months[next_month - 1].classList.add('calendar__month--active');
                }
				cleanup_first_second();
            });

        }
    }
};

export const cleanup_first_second = () => {
	// remove all first/second
	$('.calendar--twomonth .calendar__month').removeClass('first').removeClass('second');
	// identify first and second
	$('.calendar--twomonth .calendar__month--active:first').addClass('first');
	$('.calendar--twomonth .calendar__month--active:eq(1)').addClass('second');
};